<div class="modal__content">
    <div class="modal__list">
        <div class="checkout__item" *ngFor="let service of autographServices" [class.item--selected]="isSelected(service)" (click)="select(service)">
            <h5>{{service.name}}</h5>
            <p *ngIf="isEncapsulation(service)">For items 6.5'' x 8.75'' or smaller</p>
        </div>
    </div>
</div>
<modal-actions [options]="options" [type]="type"></modal-actions>